import React from "react";
import TabNavigation from "Components/common/TabNavigation";
import Routing from "./Routing";
import { DIALER_SETTINGS_TAB_NAV } from "./Constant";
import Utils from "Utils/utils";

export const Main = () => {
  const isAdmin = Utils.isAdmin();
  const tabList = DIALER_SETTINGS_TAB_NAV.filter(tab => !tab.adminOnly || isAdmin);
  return (
    <section className="callSettingContainer">
      <TabNavigation tabList={tabList} />
      <div className="callSettingContent">
        <Routing />
      </div>
    </section>
  );
};
export default Main;
